/**
 * AddressAutocomplete — input de dirección con Google Places Autocomplete opcional.
 *
 * NER-4257: se usa en el wizard de registro (Step 2) para recolectar la dirección
 * del negocio/consultorio de forma cross-vertical (Citame/Consultame).
 *
 * - Sin API key (REACT_APP_GOOGLE_MAPS_API_KEY): renderiza un <input> de texto
 *   plano y NO carga @react-google-maps/api. Este admin hoy no inyecta la key en
 *   CI → siempre usa este camino, así el registro no arrastra ~31KB de maps ni
 *   depende de red externa.
 * - Con API key: carga GooglePlacesInput de forma lazy (chunk aparte) para el
 *   autocompletado, manteniendo el bundle crítico del registro liviano.
 */

import React, { Suspense, lazy } from 'react';

const GooglePlacesInput = lazy(() => import('./GooglePlacesInput'));

function AddressAutocomplete({
  value,
  onChange,
  onPlaceSelected,
  placeholder,
  id = 'businessAddress',
  name = 'businessAddress',
  className,
}) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  const plainInput = (
    <input
      type="text"
      id={id}
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
    />
  );

  if (!apiKey) {
    return plainInput;
  }

  return (
    <Suspense fallback={plainInput}>
      <GooglePlacesInput
        apiKey={apiKey}
        value={value}
        onChange={onChange}
        onPlaceSelected={onPlaceSelected}
        placeholder={placeholder}
        id={id}
        name={name}
        className={className}
      />
    </Suspense>
  );
}

export default AddressAutocomplete;
